import { Portal } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core/next';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const RewardedAdModal = ({ isOpen, onClose }: Props) => {
  return (
    isOpen && (
      <Portal>
        <div
          className="fixed left-0 top-0 z-[9999] size-full bg-legacy-noir px-4"
          data-cy-id="rewarded-ad-modal"
        >
          <div className="pb-[env(safe-area-inset-bottom)] pt-[env(safe-area-inset-top)]">
            <div className="grid h-[calc(100svh-env(safe-area-inset-top)-env(safe-area-inset-bottom))]">
              <div className="grid grid-rows-[40px_auto]">
                <div className="grid justify-end">
                  <Button
                    type="button"
                    variant="subtle"
                    onClick={onClose}
                    aria-label="Close"
                    data-cy-id="ad-modal-close-btn"
                    className="p-0"
                  >
                    <CrossSolid className="fill-p-white" />
                  </Button>
                </div>
                <div className="grid grid-rows-2 items-center">
                  <div className="text-center text-xl text-solid">
                    Ad Container
                  </div>
                  <div className="grid grid-rows-2 gap-2">
                    <Button>See pricing and benefits</Button>
                    <Button variant="outline">
                      Watch ad and unlock for 24h
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Portal>
    )
  );
};
